import React from "react";

import {
  Chelsea,
  Liverpool,
  ManCity,
  Arsenal,
  ManU,
  LeicesterCity,
  BlackburnRovers,
} from "../clubs";

const Epl = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won English Premier League (EPL).</h1>
      
        <Liverpool />
        <ManCity />
        <Chelsea />
        <LeicesterCity />
        <ManU />
        <Arsenal />
        <BlackburnRovers />
      
    </div>
  );
};

export default Epl;
